<template>
    <div id="base-router">
        <section class="base-router">
            <h1 class="title">Base-Router</h1>
            <div class="sider-bar">
                <router-link :to="{ path: '/baseRouter/first' }">First page</router-link>
                <router-link to="/baseRouter/second">Second page</router-link>
            </div>
            <div class="main-content">
                <router-view class="view"></router-view>
            </div>
        </section>

    </div>
</template>

<script>
import firstComponent from './firstComponent.vue'
import secondComponent from './secondComponent.vue'

export default {
    data() {
        return {

        }
    },
    methods: {

    },
    mounted() {


    },
    components:{
        'firstComponent': firstComponent,
        'secondComponent':secondComponent
    }

}
</script>



// WEBPACK FOOTER //
// baseRouter.vue?d6bf5306